export default {
    checkbox: 'The goods have been inspected',
    feedback: 'The field is required to fill in!',
    saveButton: 'Generate a refund',

    fields: {
        id: 'Operation number',
        orderId: 'Order number',
        refundType: 'Type of refund',
        refundDate: 'Operation date',
        refundStatus: 'Refund status',
        exchangeReasonDescription: 'Exchange reason',
        exchangeDate: 'Operation date',
        partnerName: 'Partner name',
    },
};